import React from 'react'
import "./header.styles.css"

export default function Header() {
    return (
        <div className="header">
            <h1 className="header-title"><a href="/">Universe Of Games</a></h1>
        </div>
    )
}
